<template>
    <form  action="https://formsubmit.co/wonganichipofya98@gmail.com" method="POST">
        <div class="control">
            <div class="label">Your Name</div>
            <input type="text" class="input" name="name" required>
        </div>
        <div class="control">
            <div class="label">Your Email Address</div>
            <input type="text" class="input" name="email" required>
        </div>
        <div class="control">
            <div class="label">Subject</div>
            <input type="text" class="input" name="_subject" required>
        </div>
        <div class="control">
            <div class="label">Message</div>
            <textarea class="input text" name="message" required></textarea>
        </div>
        <input type="hidden" name="_next" value="https://helixwchipofya.netlify.app/sent" required>
        <div class="control buttons">
            <button class="btn">Send</button>
            <!-- <button class="btn inverse">Reset</button> -->
        </div>
    </form>
</template>
<style scoped>
    .input{
        padding:0.3rem;
        font-family:var(--text);
        min-width: 30rem;
        border-radius: var(--radius);
        border:1px solid ;
    }
    .btn{
        margin-right:0.5rem;
        font-family: var(--text);
        border:0px;
        border-radius: var(--radius);
        font-size:1rem;
        padding:0.4rem 1rem;
        color:white;
        background-color: var(--blue);
    }

    .inverse{
        background-color: rgb(230, 230, 230);
        color:var(--blue);
    }

    .control{
        margin-bottom: 1rem;
    }

    .label{
        margin-bottom: 0.3;
    }

    .text{
        min-height: 10rem;
        resize: none;
    }

    @media(max-width: 768px){
        .input{
        
        min-width:auto;
        width:100%;
    
        
    }
    }
</style>
